<!-- Responsibility: Implement player profile vitals behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->

<!--vitals should be a component that is being used in several places, you fucker! not just for user! make it game-generic!-->
<player-profile-vitals>
  <section class="pp-section" if={ props.vitals && props.vitals.length }>
    <h5 class="pp-section-title">VITALS</h5>
    <div class="pp-vitals">
      <div
        each={ vital in props.vitals }
        class="pp-vital { vital.tone }"
        role="button"
        tabindex="0"
        aria-label={ `Open ${vital.key} details. Current ${vital.value} out of ${vital.max}` }
        onclick={ () => props.onOpen && props.onOpen(vital) }
        onkeydown={ (e) => props.onActivateKey && props.onActivateKey(e, () => props.onOpen && props.onOpen(vital)) }
      >
        <div class="pp-vital-label">{ vital.label }</div>
        <div class="pp-vital-track"><div class="pp-vital-fill { vital.tone }" style={ `width:${vital.percent}%; background-image:${fillGradient(vital.tone)}` }></div></div>
        <div class="pp-vital-value">{ vital.value } / { vital.max }</div>
      </div>
    </div>
  </section>

  <script>
    const VITAL_GRADIENTS = {
      vitality: 'linear-gradient(90deg, #7f1d1d, #ef4444)',
      spirit: 'linear-gradient(90deg, #1d4ed8, #38bdf8)',
      essence: 'linear-gradient(90deg, #6d28d9, #c084fc)',
    }

    export default {
      fillGradient(tone) {
        return VITAL_GRADIENTS[tone] || VITAL_GRADIENTS.vitality
      },
    }
  </script>

  <style>
    .pp-section { animation: section-in 0.5s ease both; }
    .pp-section-title {
      color: var(--text-dim);
      font-size: var(--space-sm);
      letter-spacing: 0.25em;
      margin: 0 0 1.25rem;
      border-bottom: 1px solid var(--border);
      padding-bottom: var(--space-xs);
    }
    .pp-vitals { display: grid; grid-template-columns: repeat(3, 1fr); gap: var(--space-lg); }
    .pp-vital {
      display: flex; flex-direction: column; gap: var(--space-xs); cursor: pointer; padding: var(--space-sm) var(--space-sm) 0.6rem;
      border: 1px solid color-mix(in srgb, var(--border) var(--alpha-subtle), #4b5f7e); border-radius: 0.375rem;
      background: color-mix(in srgb, var(--surface-card-2) var(--alpha-high), var(--bg));
      transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;
    }
    .pp-vital:hover { transform: translateY(-1px); background: color-mix(in srgb, var(--surface-card-1) var(--alpha-high), var(--bg)); }
    .pp-vital:hover .pp-vital-label { color: #f8fbff; }
    .pp-vital.vitality { border-color: color-mix(in srgb, var(--vital-hp) var(--alpha-mid), var(--border)); }
    .pp-vital.vitality .pp-vital-label { color: var(--sem-danger-fg); }
    .pp-vital.vitality .pp-vital-value { color: var(--vital-hp); }
    .pp-vital.spirit { border-color: color-mix(in srgb, var(--vital-sp) var(--alpha-mid), var(--border)); }
    .pp-vital.spirit .pp-vital-label { color: var(--sem-info-fg); }
    .pp-vital.spirit .pp-vital-value { color: var(--vital-sp); }
    .pp-vital.vitality .pp-vital-value { color: var(--vital-hp); }
    .pp-vital.spirit .pp-vital-value { color: var(--vital-sp); }
    .pp-vital.essence .pp-vital-value { color: var(--vital-es); }
    .pp-vital-label { font-size: var(--space-sm); font-weight: bold; letter-spacing: 0.07em; color: var(--text-muted); transition: color 0.2s; }
    .pp-vital-track { height: 0.625rem; background: linear-gradient(180deg, var(--bg), var(--surface-card-3)); border: 1px solid var(--border); border-radius: 62.4375rem; overflow: hidden; box-shadow: inset 0 1px 1px rgba(0,0,0,0.62); }
    .pp-vital-fill { height: 100%; transition: width 0.6s cubic-bezier(0.34,1.56,0.64,1); box-shadow: 0 0 0.625rem var(--alpha-low); }
    .pp-vital-fill.vitality { background: linear-gradient(90deg, color-mix(in srgb, var(--vital-hp) 80%, black), var(--vital-hp)); }
    .pp-vital-fill.spirit { background: linear-gradient(90deg, color-mix(in srgb, var(--vital-sp) 80%, black), var(--vital-sp)); }
    .pp-vital-fill.essence { background: linear-gradient(90deg, color-mix(in srgb, var(--vital-es) 80%, black), var(--vital-es)); }
    .pp-vital-value {
      font-size: 1.1rem;
      font-weight: bold;
      color: color-mix(in srgb, var(--text-prose) 96%, #fff);
      text-align: right;
      line-height: 1;
      letter-spacing: 0.02em;
    }
    .pp-vital.vitality .pp-vital-value,
    .pp-vital.spirit .pp-vital-value,
    .pp-vital.essence .pp-vital-value {
      color: color-mix(in srgb, var(--text-prose) 96%, #fff);
    }
    @media (max-width: 40.625rem) { .pp-vitals { grid-template-columns: 1fr; gap: var(--space-md); } }
  </style>
</player-profile-vitals>
